// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import React, { ErrorInfo } from 'react';
import { BotServerAppInsights } from 'utils/BotServerAppInsights';

type SpeakToBotErrorBoundaryProps = {
  children: React.ReactNode;
  appInsights?: BotServerAppInsights;
};

/**
 * @private
 */
export class SpeakToBotErrorBoundary extends React.Component<SpeakToBotErrorBoundaryProps> {
  appInsights?: BotServerAppInsights;

  constructor(props: SpeakToBotErrorBoundaryProps) {
    super(props);
    this.appInsights = props.appInsights;
  }

  componentDidUpdate(prevProps: SpeakToBotErrorBoundaryProps): void {
    if (prevProps.appInsights !== this.props.appInsights) {
      this.appInsights = this.props.appInsights;
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    this.appInsights?.trackException({
      exception: error,
      properties: {
        errorMessage: error.message,
        componentStack: info.componentStack,
        name: 'BotSession_UnknownException'
      }
    });
  }

  render(): React.ReactNode {
    return this.props.children;
  }
}
